import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router';
import { FormattedMessage } from 'react-intl';
import Isvg from 'react-inlinesvg';
import BLUETOOTH_STATUS from 'constants/bluetooth';
export var DeviceSetupConnection =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DeviceSetupConnection, _React$Component);

  function DeviceSetupConnection() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, DeviceSetupConnection);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DeviceSetupConnection)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "getNoConnectionScreen", function () {
      var handleStandardPlay = _this.props.handleStandardPlay;
      return [React.createElement("div", {
        className: "modal__device-setup__top",
        key: "device.connection.top"
      }, React.createElement(FormattedMessage, {
        id: "device.header-failed",
        defaultMessage: "Connection unsuccessful",
        tagName: "h3"
      }), React.createElement(FormattedMessage, {
        id: "device.suggestion",
        defaultMessage: "We\u2019re having trouble connecting to your heart rate monitor. Try to un-snap and re-snap the Wahoo TICKR sensor.",
        tagName: "p"
      })), React.createElement("div", {
        className: "modal__device-connection modal__device-setup__content",
        key: "device.connection.content"
      }, React.createElement("img", {
        src: require('../../../static/img/setup-device.svg'),
        alt: "No Connection",
        className: "modal__device-connection__no-wearable p++"
      }), React.createElement("button", {
        className: "bt bt--primary mt+",
        onClick: _this.props.connectBluetoothDevice // eslint-disable-line react/jsx-handler-names
        ,
        key: "device.connection.button"
      }, "Try connecting again"), React.createElement("div", {
        id: "connection-error",
        className: "mt"
      }, React.createElement("p", {
        className: "inline-block"
      }, React.createElement(FormattedMessage, {
        id: "connection-error-prompt",
        defaultMessage: "Having trouble connecting?"
      })), React.createElement(Link, {
        onClick: function onClick() {
          return handleStandardPlay();
        },
        className: "md-inline-block sm-block pl- mt+"
      }, React.createElement(FormattedMessage, {
        id: "connection-error-play-video",
        defaultMessage: "Watch video only"
      }))))];
    });

    _defineProperty(_assertThisInitialized(_this), "getConnectedScreen", function () {
      var device = _this.props.device;
      return [React.createElement("div", {
        className: "modal__device-setup__top",
        key: "device.connection.top"
      }, React.createElement("h3", null, React.createElement(FormattedMessage, {
        id: "device.current-hr",
        defaultMessage: "Your current heart rate"
      }))), React.createElement("div", {
        className: "modal__device-connection modal__device-setup__content",
        key: "device.connection.content"
      }, React.createElement("div", null, React.createElement("span", {
        className: "modal__device-connection__bpm"
      }, device.bpm || '--'), React.createElement("span", {
        className: "modal__device-connection__bpm-label"
      }, React.createElement(FormattedMessage, {
        id: "device.heart.rate",
        defaultMessage: "Heart rate"
      })), React.createElement("span", {
        className: "inline-block mv+"
      }, React.createElement(Isvg, {
        className: "modal__device-connection__device-label svg mr--",
        src: require('../../../static/img/icon/bluetooth-teal.svg')
      }), React.createElement("span", {
        className: "modal__device-connection__device-label"
      }, device.connection))), React.createElement("button", {
        className: classNames('bt bt--primary bt--width-md mt+', {
          'bt--disabled': !device.bpm
        }),
        disabled: !device.bpm,
        onClick: _this.handleConnectionComplete,
        key: "device.connection.button"
      }, "Next"))];
    });

    _defineProperty(_assertThisInitialized(_this), "handleConnectionComplete", function () {
      var _this$props = _this.props,
          alias = _this$props.alias,
          inSession = _this$props.inSession,
          hideModal = _this$props.hideModal,
          updateDevice = _this$props.updateDevice,
          joinClass = _this$props.joinClass;

      if (inSession) {
        // resuming an existing session so we need to
        // ensure we join the class again to setup the
        // state of the bluetooth flow and leaderboard
        // flow correctly.
        joinClass(alias, 'INTERACTIVE');
        hideModal('DeviceSetupModal');
      } else {
        updateDevice({
          status: BLUETOOTH_STATUS.READY_TO_CAST
        });
      }
    });

    return _this;
  }

  _createClass(DeviceSetupConnection, [{
    key: "getPairingScreenStage1",
    value: function getPairingScreenStage1() {
      return [React.createElement("div", {
        className: "modal__device-setup__top",
        key: "device.connection.top"
      }, React.createElement(FormattedMessage, {
        id: "device.pairing-header",
        defaultMessage: "Pairing heart rate monitor",
        tagName: "h3"
      })), React.createElement("div", {
        className: "modal__device-connection modal__device-setup__content",
        key: "device.connection.content"
      }, React.createElement("img", {
        src: require('../../../static/img/bluetooth.gif'),
        className: "modal__device-connection__connect-animation",
        alt: "bluetooth"
      }), React.createElement("p", {
        className: "text--light m+"
      }, React.createElement(FormattedMessage, {
        id: "device.pairing-message",
        defaultMessage: "Pairing with your device..."
      })))];
    }
  }, {
    key: "getPairingScreenStage2",
    value: function getPairingScreenStage2() {
      return [React.createElement("div", {
        className: "modal__device-setup__top",
        key: "device.connection.top"
      }, React.createElement(FormattedMessage, {
        id: "device.pairing-hr-header",
        defaultMessage: "Pairing heart rate monitor",
        tagName: "h3"
      })), React.createElement("div", {
        className: "modal__device-connection modal__device-setup__content",
        key: "device.connection.content"
      }, React.createElement("img", {
        src: require('../../../static/img/heart.gif'),
        className: "modal__device-connection__connect-animation",
        alt: "heart"
      }), React.createElement("p", {
        className: "text--light m+"
      }, React.createElement(FormattedMessage, {
        id: "device.reading-hr-message",
        defaultMessage: "Reading heart rate..."
      })))];
    }
  }, {
    key: "render",
    value: function render() {
      var device = this.props.device;
      return React.createElement("div", {
        className: "modal__device-connection"
      }, [BLUETOOTH_STATUS.DEVICE_DISCONNECTED, BLUETOOTH_STATUS.DEVICE_FAILED].indexOf(device.status) > -1 && this.getNoConnectionScreen(), device.status === BLUETOOTH_STATUS.DEVICE_CONNECTED && this.getConnectedScreen(), [BLUETOOTH_STATUS.DEVICE_PAIRING_STAGE1, BLUETOOTH_STATUS.DEVICE_SELECTION].indexOf(device.status) > -1 && this.getPairingScreenStage1(), device.status === BLUETOOTH_STATUS.DEVICE_PAIRING_STAGE2 && this.getPairingScreenStage2());
    }
  }]);

  return DeviceSetupConnection;
}(React.Component);
DeviceSetupConnection.propTypes = {
  alias: PropTypes.string,
  device: PropTypes.object,
  connectBluetoothDevice: PropTypes.func,
  handleStandardPlay: PropTypes.func,
  hideModal: PropTypes.func,
  inSession: PropTypes.bool,
  updateDevice: PropTypes.func,
  joinClass: PropTypes.func
};